export const requestBookmarksQuery = () => `
  {
    bookmarks {
      id
      symbol
      bmcomment
      username
      timestamp
    }
  }
`;

export const addBookmarkQuery = () => `
  mutation AddBookmark ($bookmarkInput: AddBookmarkInput!) {
    addBookmark (
      addBookmarkInput: $bookmarkInput
    ) {
      id,
      symbol,
      bmcomment,
      timestamp
      username
    }
  }
`;

export const editBookmarkQuery = () => `
  mutation EditBookmark ($bookmarkInput: EditBookmarkInput!) {
    editBookmark (
      editBookmarkInput: $bookmarkInput
    ) {
      id,
      symbol,
      bmcomment,
      timestamp
      username
    }
  }
`;

export const deleteBookmarkQuery = () => `
  mutation DeleteBookmark ($bookmarkInput: DeleteBookmarkInput!) {
    deleteBookmark (
      deleteBookmarkInput: $bookmarkInput
    ) {
      id,
      symbol,
      bmcomment,
      timestamp
      username
    }
  }
`;